(() => {
  // Fallback for browsers without exclusive <details name> groups.
  document.querySelectorAll('.si-accordions').forEach(group => {
    const panels = [...group.querySelectorAll('.si-faq')];
    panels.forEach(panel => panel.addEventListener('toggle', () => {
      if (panel.open) panels.forEach(other => {
        if (other !== panel) other.open = false;
      });
    }));
  });
  const form = document.querySelector('.si-form');
  const topicInput = form?.querySelector('[data-topic-input]');
  const topicCopy = document.querySelector('.si-form-topic');
  document.querySelectorAll('[data-contact-topic]').forEach(button => {
    button.addEventListener('click', () => {
      document.querySelectorAll('[data-contact-topic]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
      if (topicInput) topicInput.value = button.dataset.contactTopic;
      if (topicCopy) topicCopy.textContent = button.dataset.contactTopic === 'Party favours' ? 'Let’s talk about your celebration.' : 'A little help with your order.';
    });
  });
})();
